import { EliteWrappedFrame, EliteWrappedResponse } from '../types/eliteWrapped.types'

const LINE_KEYS = ['line1', 'line2', 'line3', 'line4', 'line5', 'line6'] as const

/** elite-recap.riv uses zero-based frame suffixes (Line1_0, Line1_1, …). */
export function frameDataToTextRunValues(frameData: EliteWrappedFrame[] | undefined): Record<string, string> {
  const textRunValues: Record<string, string> = {}
  if (!frameData?.length) return textRunValues

  frameData.forEach((frame, index) => {
    LINE_KEYS.forEach((lineKey, lineIndex) => {
      const value = frame?.[lineKey]
      if (value) {
        textRunValues[`Line${lineIndex + 1}_${index}`] = value
      }
    })
  })

  return textRunValues
}

/** Story frames only — renew CTA is applied separately via `applyEliteRenewTextRun`. */
export function eliteWrappedToTextRunValues(data: EliteWrappedResponse | undefined): Record<string, string> {
  return frameDataToTextRunValues(data?.frameData)
}
